import { Component, inject } from '@angular/core';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { MatCard, MatCardContent } from '@angular/material/card';
import { CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-credit-summary',
  templateUrl: './credit-summary.component.html',
  styleUrls: ['./credit-summary.component.scss'],
  imports: [MatCard, MatCardContent, CurrencyPipe, TranslateModule],
})
export class CreditSummaryComponent {
  private clientsService = inject(ClientsService);

  get client() {
    return this.clientsService.selectedClientSubject.value;
  }
}
